import React, { ReactNode } from "react";
import { BaseBotData, OrderTypes } from "@shared/types";
import useBotStrategySummary from "features/bots/BotDrawer/useBotStrategySummary";
import ConfigurationItem from "features/admin/TradingConfiguration/ConfigurationItem";

interface BotStrategySummaryProps {
  botData: BaseBotData;
  orderType: OrderTypes;
}

const AdminStrategySummary = ({
  botData,
  orderType,
}: BotStrategySummaryProps) => {
  const parsedStrategySummary = useBotStrategySummary({
    botData,
    orderType,
    isAdminConfiguration: true,
  });
  if (!parsedStrategySummary) return null;

  const items: ReactNode[] | undefined = parsedStrategySummary?.map(
    (data: any) => {
      return (
        <ConfigurationItem
          key={data.title}
          title={data.title}
          value={data.value}
        />
      );
    }
  );

  return <>{items}</>;
};

export default AdminStrategySummary;
